import "./x-scroll-panel-nav.scss";
import XScroll from "../_x-scroll/x-scroll-util";

XScroll();
